import { render, staticRenderFns } from "./supportMail.vue?vue&type=template&id=e3e8dec0&lang=pug&"
import script from "./supportMail.vue?vue&type=script&lang=js&"
export * from "./supportMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports